import React from 'react'
import DataTable from 'react-data-table-component';
import OpenModal from '../helper/OpenModal';
import AddNews from './AddNews';
import { useState } from 'react';
import { useEffect } from 'react';
import moment from "moment"
import 'moment/locale/es';
import { useAlert } from "react-alert";
import DeleteRow from './DeleteRow';

export default function ShowNews() {
    let alert = useAlert();
    const [newsdata, setnewsdata] = useState([]);

    useEffect(() => {
        getNews()
    }, [])

    const getNews = () => {
        fetch(
            `${process.env.REACT_APP_URL_API}/data/getNews`,
            {
                method: "GET",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache",
                    "Access-Control-Allow-Origin": "*",
                },
            }
        )
            .then((response) => response.json())
            .then((data) => {
                setnewsdata(data);
            })
            .catch((error) => {
                alert.show("Ocurrió un error al obtener las noticias", {
                    timeout: 3000,
                    type: "error",
                });
            });
    }

    const columns = [
        {
            name: 'Titulo',
            selector: row => row.info.title,
        },
        {
            name: 'Fecha',
            selector: row => moment(row.info.createdAt).format("LLL"),
        },
        {
            name: "Editar",
            button: "true",
            cell: (row) => (
                <>
                    <OpenModal title={`Editar noticia`} type="primary" buttontext="Editar" children={<AddNews itsEditing={true} data={row} />} />
                </>
            ),
        },
        {
            name: "Eliminar",
            button: "true",
            cell: (row) => (
                <>
                    <DeleteRow type={"News"} id={row.info.idnews} title={row.info.title} />
                </>
            ),
        },
    ];

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    return (
        <div>
            <div className="row">
                <p className='text-center'>Agrega o modifica noticias</p>
            </div>
            <OpenModal title={`Nueva noticia`} buttontext="Nuevo" type="success" children={<AddNews itsEditing={false} data={{}} />} />
            <DataTable
                columns={columns}
                noDataComponent="Sin datos que mostrar"
                data={newsdata}
                paginationComponentOptions={paginationComponentOptions}
                pagination
            />
        </div>
    )
}
